import { render, staticRenderFns } from "./Documents_ID.vue?vue&type=template&id=3cb6c728&scoped=true&"
import script from "./Documents_ID.vue?vue&type=script&lang=js&"
export * from "./Documents_ID.vue?vue&type=script&lang=js&"
import style0 from "./Documents_ID.vue?vue&type=style&index=0&id=3cb6c728&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb6c728",
  null
  
)

export default component.exports